import { MdAutoFixHigh } from 'react-icons/md';
import type { SATheme } from '../../types/stylingAssistant.types';

interface SASummaryCardProps {
  theme: SATheme;
  summary: string;
}

export default function SASummaryCard({ theme, summary }: SASummaryCardProps) {
  if (!summary) return null;

  return (
    <div
      className="px-4 py-3.5 rounded-2xl transition-all duration-500 animate-fadeIn"
      style={{
        backgroundColor: 'rgba(238, 68, 35, 0.06)',
        border: '1px solid rgba(238, 68, 35, 0.15)',
      }}
    >
      <div className="flex items-start gap-3">
        <div className="w-6 h-6 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5 bg-[#EE4423]/10">
          <MdAutoFixHigh size={14} className="text-[#EE4423]" />
        </div>
        <p className="text-sm leading-relaxed" style={{ color: theme.text }}>
          {summary}
        </p>
      </div>
    </div>
  );
}
